const accountAction = {
    APPLY_CHANGES : 'apply changes',

    CREATE_ACCOUNT_PROPOSAL : 'create account proposal',

    CREATE_SUBMISSION : 'create submission',

    DELETE_ACCOUNT : 'delete account',

    DISCARD_CHANGES : 'discard changes',

    MERGE_ACCOUNTS : 'merge accounts',

    MODIFY_ACCOUNT : 'modify account'

};

angular.module('gw-um-j2js')
    .constant('accountAction', accountAction);